import { useBreakpoints } from "@aurem/ui";
import { useTranslations } from "../i18n";
import { SearchInput } from "../SearchInput";
import { FiltersPanel } from "./FiltersPanel";
import { FiltersPopover } from "./FiltersPopover";
import { LoadingState } from "./LoadingState";
import { QueryToolbarProps } from "./types";

export const QueryToolbar = (props: QueryToolbarProps) => {
  const {
    actions,
    quickFilters,
    filters,
    filtersPopover,
    filtersCount,
    onResetFilters,
    inputProps,
    loading,
    debounce,
  } = props;
  const { t } = useTranslations();
  const { isMobile } = useBreakpoints();

  if (loading) {
    return <LoadingState {...props} />;
  }

  const mobilePopoverContent =
    isMobile && (quickFilters || filtersPopover) ? (
      <div className="flex flex-col gap-4">
        {quickFilters}
        {filtersPopover}
      </div>
    ) : null;

  return (
    <nav
      className="flex items-center gap-2 w-full"
      role="toolbar"
      aria-label={t("components.queryToolbar.ariaQueryToolbar")}
    >
      <div
        className="flex items-center flex-grow min-w-0 gap-2"
        role="group"
        aria-label={t("components.queryToolbar.ariaSearchAndFilters")}
      >
        <SearchInput
          className="max-w-[14.375rem] xl:max-w-[20rem]"
          {...inputProps}
          debounce={debounce}
        />
        {!isMobile && quickFilters}
        {filters && <FiltersPanel {...props} />}
        {isMobile
          ? mobilePopoverContent && (
              <FiltersPopover
                filtersCount={filtersCount}
                onResetFilters={onResetFilters}
              >
                {mobilePopoverContent}
              </FiltersPopover>
            )
          : filtersPopover && (
              <FiltersPopover
                filtersCount={filtersCount}
                onResetFilters={onResetFilters}
              >
                {filtersPopover}
              </FiltersPopover>
            )}
      </div>
      {actions && (
        <div
          className="flex items-center justify-end shrink-0 gap-2"
          role="group"
          aria-label={t("components.queryToolbar.ariaActions")}
        >
          {actions}
        </div>
      )}
    </nav>
  );
};
